import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { COMMENT_APP_ID } from '@src/public/constants';
import { isGrounds, isIos7380, openAppShare, userIsLogin, userLogin } from '@src/public/utils/app';
import { formatPeopleCount } from '@src/public/utils/format';
import { linkBase } from '@src/mobile/components/Link';
import { Sheet } from '@src/mobile/components/ModalBox';
import { likeCommentApi } from '../services';
import styles from './index.css';
import Share from './Share';
import CommentModal from './CommentModal';

const cx = classNames.bind(styles);

/**
 * 互动配置项
 */
export const BUSINESS_TYPE = {
    like: 1,
    ding: 21,
    cai: 20,
    flower: 3,
    candle: 4,
    cheer: 5,
};

const likeConfigMap = new Map([
    [0, { keys: [], classes: [] }],
    [1, { keys: ['like'], classes: ['like'] }],
    [2, { keys: ['ding', 'cai'], classes: ['ding', 'cai'] }],
    [3, { keys: ['flower'], classes: ['flower'] }],
    [4, { keys: ['candle'], classes: ['candle'] }],
    [5, { keys: ['cheer'], classes: ['cheer'] }],
]);

const Footer = ({ content, timeline, index }) => {
    const { interaction, likeConfig, id, allowComment } = content;
    const { comment } = interaction;
    const { allowComment: timelineAllowComment } = timeline;
    const itemAllowComment = allowComment === 1;
    const finalAllowComment = timelineAllowComment && itemAllowComment;

    const likconfigData = likeConfigMap.get(likeConfig);
    const { keys: likconfigKeys, classes: likconfigClasses } = likconfigData;
    const interactionInitState = likconfigKeys.map((key, index) => {
        const { count, choosen } = interaction[key];
        const iconClass = likconfigClasses[index];
        const checked = !!choosen;

        return { key, count, checked, iconClass };
    });
    const [interactionList, setInteractionList] = useState(interactionInitState);

    // TODO: 把所有的图标聚合到一个数组中
    const colLength = interactionList.length + isGrounds ? 2 : 1;
    const colWidth = `${100 / colLength}%`;

    const [showCommentGuide, setShowCommentGuide] = useState(false);

    const closeCommentGuide = () => {
        if (showCommentGuide) {
            setShowCommentGuide(false);
        }
    };

    const [showComment, setShowComment] = useState(false);

    const handleComment = () => {
        if (finalAllowComment) {
            setShowComment(true);
            closeCommentGuide();
        }
    };

    const handleCloseComment = () => {
        setShowComment(false);
    };

    const [showShare, setShowShare] = useState(false);

    const handleShowShare = showShare => {
        setShowShare(showShare);
    };

    const handleShare = () => {
        if (isIos7380()) {
            const url = `${linkBase}/loc/timeline/event/${timeline.id}`;
            const title = timeline.title;
            const desc = timeline.summary;
            const shareImgUrl = timeline.shareImgUrl;

            openAppShare({ url, title, desc, thumbnail: shareImgUrl });
        } else {
            handleShowShare(true);
        }
    };

    useEffect(
        () => {
            if (index === 0) {
                try {
                    const localKey = 'timeline/hasShowCommentGuide';
                    const hasShowCommentGuide = !!window.localStorage.getItem(localKey);

                    if (!hasShowCommentGuide) {
                        setShowCommentGuide(true);
                        window.localStorage.setItem(localKey, '1');
                    }
                } catch (e) {
                    console.error(e);
                }
            }
        },
        [index],
    );

    const handleCommentGuideClick = e => {
        e.stopPropagation();
        closeCommentGuide();
    };

    return (
        <div className={cx('wrap', { wrapSingle: colLength === 1 })}>
            {interactionList.map((item, index) => {
                const { key, count, checked, iconClass } = item;
                const handleClick = async () => {
                    // 校验登录状态
                    if (!userIsLogin()) {
                        userLogin();

                        return;
                    }
                    // 发接口请求
                    const { code } = await likeCommentApi(
                        COMMENT_APP_ID,
                        id,
                        BUSINESS_TYPE[key],
                        checked ? 'DEL' : 'INSERT',
                    );

                    if (code !== 200) {
                        // 提示
                        return;
                    }

                    // 前端修改状态
                    setInteractionList(prevList =>
                        prevList.map((item, subIndex) => {
                            if (index === subIndex) {
                                const { key, count, checked, iconClass } = item;
                                const newCount = checked ? count - 1 : count + 1;
                                const newChecked = !checked;

                                return {
                                    key,
                                    count: newCount,
                                    checked: newChecked,
                                    iconClass,
                                };
                            } else if (item.checked) {
                                const { key, count, checked, iconClass } = item;
                                const newCount = count - 1;
                                const newChecked = !checked;

                                return {
                                    key,
                                    count: newCount,
                                    checked: newChecked,
                                    iconClass,
                                };
                            } else {
                                return item;
                            }
                        }),
                    );
                };

                return (
                    <div className={styles.col} key={key} onClick={handleClick} style={{ width: colWidth }}>
                        <div className={cx('icon', iconClass, { checked })} />
                        <div>{count > 0 ? formatPeopleCount(count) : ''}</div>
                    </div>
                );
            })}
            <div
                className={cx('col', { colNotAllowComment: !finalAllowComment, colSingle: colLength === 1 })}
                style={{ width: colWidth }}
                onClick={handleComment}>
                {!isGrounds && finalAllowComment && showCommentGuide ? (
                    <>
                        <div className={styles.commentGuide} onClick={handleCommentGuideClick}>
                            <div className={styles.commentGuideContent}>
                                <div className={styles.commentGuideText}>新功能开放，点击参与讨论哦~</div>
                                <div className={styles.commentGuideClose} />
                            </div>
                        </div>
                        <div className={styles.commentGuideArrow} onClick={handleCommentGuideClick} />
                    </>
                ) : null}
                <div className={cx('icon', 'comment')} />
                <div>{comment > 0 ? formatPeopleCount(comment) : '评论'}</div>
            </div>
            {isGrounds ? (
                <div className={styles.col} style={{ width: colWidth }} onClick={handleShare}>
                    <div className={cx('icon', 'share')} />
                    <div>转发</div>
                </div>
            ) : null}
            <Share showShare={showShare} handleShowShare={handleShowShare} content={content} timeline={timeline} />
            <Sheet top={80} show={showComment} onClose={handleCloseComment}>
                <CommentModal subjectId={id} close={handleCloseComment} allowComment={finalAllowComment} />
            </Sheet>
        </div>
    );
};

Footer.propTypes = {
    timeline: PropTypes.object,
    content: PropTypes.object,
    index: PropTypes.number,
};

export default errorBoundary(Footer);
